<template lang="pug">
  .main-field-info
    v-icon(small @click="dialog = true") search
    v-dialog(v-model="dialog" max-width="1000")
      v-card(min-height="300px")
        v-card-text.pa-0
          v-tabs(v-model='tabs' fixed-tabs='' color="primary" slider-color="white")
            v-tab.white--text(href='#field-info')
              | Informações
            v-tab.white--text(href='#field-charts')
              | Gráficos
            v-tab.white--text(href='#field-params')
              | Parâmetros
            //v-tab.white--text(href='#select-image')
              | Imagens
          v-tabs-items.white.elevation-1(v-model='tabs')
            v-tab-item(value="field-info")
              v-container(fluid grid-list-md)
                v-layout(row wrap)
                  v-flex(xs12)
                    span.title {{ component.label }}
                  v-flex(xs12 sm6 md6 lg4)
                    v-card
                      v-card-title
                        h4 Campos utilizados no cálculo
                      v-divider
                      v-list(dense)
                        v-list-tile(v-for="item in dependencies" :key="item.id")
                          v-list-tile-content(v-bind:class="{ 'font-weight-bold' : item.required, 'red--text' : item.required && !item.value}") {{ item.label }}
                          v-list-tile-content(class="align-end") {{ item.value | formatCompType(item.type) }}
                  v-flex(xs12 sm6 md6 lg4)
                    v-card
                      v-card-title
                        h4 Onde essa informação é utilizada?
                      v-divider
                      v-list(dense)
                        v-list-tile(v-for="item in referencies" :key="item.id")
                          v-list-tile-content(v-bind:class="{ 'font-weight-bold' : item.required, 'red--text' : item.required && !item.value}") {{ item.label }}
                          v-list-tile-content(class="align-end") {{ item.value | formatCompType(item.type) }}
            v-tab-item(value="field-charts")
              field-charts(:field="field" :charts="charts" :resultForm="resultForm" height="500px"  chartHeidht="450px")
            v-tab-item(value="field-params")
              dicom-params(:field="field" @close="dialog = false")
            //v-tab-item(value="select-image")
              select-image(:id="field" v-model="resultForm[field + '.images']" :component="component" :resultForm="resultForm" imageStyle='width: 33%;')
        //v-divider
        //v-card-actions
          v-spacer
          v-btn(flat @click='dialog = false') fechar
</template>

<script>
import DicomParams from '../buttons/DicomParams'
import FieldCharts from '../buttons/FieldCharts'
import SelectImage from '../inputs/SelectImage'
// import utilObject from '@/utils/object'
import formCalcs from '@/api/formCalcs'

export default {
  name: 'btn-field-info',

  props: {
    field: {
      type: String,
      required: true
    },
    component: {
    },
    resultForm: {
    }
  },

  components: {
    DicomParams,
    FieldCharts,
    SelectImage
  },

  watch: {
    dialog (val) {
      if (val) {
        this.dependencies = this.getDependencies()
        this.referencies = this.getReferencies()
        this.charts = this.getCharts()
      }
    }
  },

  data () {
    return {
      dialog: false,
      tabs: null,
      dependencies: [],
      referencies: null,
      charts: null,
      fieldCalcs: formCalcs.fields(),
      triggerCalcs: formCalcs.triggers()
    }
  },

  methods: {
    getDependencies () {
      const fetusMatch = this.field.match(/feto_(\d)/)
      const fetus = fetusMatch ? fetusMatch[1] : null
      const formulas = this.component.formulas
      if (formulas && formulas.authors && formulas.authors[formulas.default]) {
        let formula = formulas.authors[formulas.default]
        const optionals = formula.optional || []
        let comps = []
        if (formula.params) {
          for (let field in formula.params) {
            let key = formula.params[field]
            const comp = this.fieldCalcs.fields[key]
            comp.id = key
            const id = comp.id.replace('feto$', `feto_${fetus}`)
            const item = { id: comp.id, label: comp.label, type: comp.type, required: !optionals.includes(field), value: this.resultForm[id] }
            comps.push(item)
          }
        }
        return comps
      }
      return []
    },
    getReferencies () {
      const fetusMatch = this.field.match(/feto_(\d)/)
      const fetus = fetusMatch ? fetusMatch[1] : null
      const trig = this.triggerCalcs[this.field.replace(/_\d/, '$')]
      let comps = []
      if (trig && trig.targetKeys) {
        for (let key in trig.targetKeys) {
          const comp = this.fieldCalcs.fields[key]
          const id = key.replace('feto$', `feto_${fetus}`)
          const item = { id: id, label: comp.label, type: comp.type, required: false, value: this.resultForm[id] }
          comps.push(item)
        }
        return comps
      }
      return []
    },
    getCharts () {
      const refs = this.fieldCalcs.paramRefs[this.component.param]
      const charts = []
      if (refs) {
        for (let key of refs) {
          let chart = this.fieldCalcs.fields[key]
          chart.id = key
          chart.style = 'xs12'
          chart.height = '320px'
          charts.push(chart)
        }
      }
      return charts
    }
  }
}
</script>

<style lang='stylus' scoped>
.main-field-info
  position absolute
  top -6 px
  right 10 px
</style>



// WEBPACK FOOTER //
// src/components/form/buttons/FieldInfo.vue